/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from "react";
import { Stack } from "@mui/material";

import { SidePreview, Form } from "components/Account-sign-up";
import { AccountSignUpData } from "store/types";
import { useAuthActions } from "store";
import { useActionHook, useUrlHooks } from "hooks";
import { AsyncContentMui } from "components";

const signUpInitialValues: Omit<AccountSignUpData, "invite"> = {
  first_name: "",
  last_name: "",
  company_name: "",
  domain: "",
  company_type: "",
  email: "",
  password: "",
  password_confirmation: ""
};

export const AccountSignUp: React.FC = () => {
  const { getAccountSignDataAction } = useAuthActions();
  const { queryParams } = useUrlHooks();
  const { d: token } = queryParams;

  const { data, loading, action } = useActionHook(getAccountSignDataAction, { defaultLoadingState: true });

  useEffect(() => {
    action(token);
  }, []);

  return (
    <Stack direction="row" alignItems="stretch" sx={{ width: "100vw", height: "100vh" }}>
      <SidePreview />
      <Stack sx={{ p: "46px 100px", flexGrow: 1 }}>
        <AsyncContentMui spinnerProps={{ size: 150 }} isLoading={loading}>
          <Form initialValues={{ ...signUpInitialValues, ...data }} token={token} />
        </AsyncContentMui>
      </Stack>
    </Stack>
  );
};
